"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var styles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    footer: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing.small,
        justifyContent: 'flex-end',
        padding: theme.spacing.small
    }
}); });
exports.default = styles;
//# sourceMappingURL=DialogFooter.styles.js.map